import Features from "data/features";
import { useCentralApi, useCurrentUser } from "hooks/shared";
import { useEffect, useState } from "react";

type UseFeatureEnabledResult = [boolean, boolean];
type UseFeatureEnabledSignature = (flag: Features) => UseFeatureEnabledResult;

const useFeatureEnabled: UseFeatureEnabledSignature = (flag: Features) => {
  const [enabled, setEnabled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const user = useCurrentUser();
  const fetcher = useCentralApi(user);

  useEffect(() => {
    if (!user || !user.id_token) {
        setLoading(false);
        return;
    }

    const controller = new AbortController();
    (async () => {
      try {
        const resp = await fetcher(`/api/v3/accounts/features/${flag}`, {
          signal: controller.signal,
        });

        if (!resp.ok) {
          setEnabled(false);
          return;
        }

        const data = await resp.json();
        setEnabled(Boolean(data));
      } catch {
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    })();

    return () => controller.abort();
  }, [flag, user]);

  return [enabled, loading];
};

export default useFeatureEnabled;